import { LuTrendingDown, LuTrendingUp } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { ChartRendererProps } from '../../types/chart-renderer-props';
import { toPeriodComparisonMetric } from '../../utils/to-period-comparison-metric';

const trendClassName = (direction: 'up' | 'down' | 'flat'): string => {
    if (direction === 'up') {
        return 'text-status-success';
    }

    if (direction === 'down') {
        return 'text-status-warning';
    }

    return 'text-brand-muted';
};

export const FillRateMetricChart = ({ data, className }: ChartRendererProps) => {
    const metric = toPeriodComparisonMetric(data, 'relative');

    if (!metric) {
        return null;
    }

    return (
        <div className={`flex w-full items-end justify-between gap-3 ${className ?? ''}`}>
            <div className='flex min-w-0 flex-col items-start justify-end gap-0.5'>
                <div className='text-brand-muted justify-start text-sm font-medium'>
                    <FormattedMessage
                        id='chart.components.renderers.duration-metric-chart.average-abbreviation'
                        description='Abbreviated label for the average duration value on a transaction timer duration metric chart'
                        defaultMessage='Avg.'
                    />
                </div>
                <div className='text-foreground-default justify-start text-xl font-semibold'>
                    <FormattedMessage
                        id='chart.components.renderers.fill-rate-metric-chart.slots-value'
                        description='Average fill rate shown as a SLOT count on the daily fill rate metric card; uses singular SLOT or plural SLOTs'
                        defaultMessage='{value} {value, plural, one {SLOT} other {SLOTs}}'
                        values={{ value: Math.round(metric.value) }}
                    />
                </div>
            </div>
            {metric.percentChange !== null && (
                <div className={`flex shrink-0 items-center gap-1 text-base font-semibold ${trendClassName(metric.direction)}`}>
                    {metric.direction === 'down' && <LuTrendingDown className='size-5' />}
                    {metric.direction === 'up' && <LuTrendingUp className='size-5' />}
                    {metric.percentChange}%
                </div>
            )}
        </div>
    );
};
